export interface IJobTitle {
	jobTitleId?: number;
	jobTitleRecordId?: number;
	name?: string;
	abbreviation?: string;
	effectiveStart?: string;
	effectiveEnd?: string;
}

export class JobTitle {
	name?: string;
	abbreviation?: string;
	effectiveStart?: string;
}
